import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

import EmployeeInitials from '@components/EmployeeInitials'
import ProjectItemStats from './ProjectItemStats'

class MyProjectsItem extends Component {
  static propTypes = {
    project: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func
  }

  render () {
    const { project } = this.props
    return (
      <div className={'expert-search-item-container'}>
        <div className='pull-right' style={{ marginRight: 10, marginTop: 10 }}>
          {this.props.project.employeeData.map(employee => (
            <EmployeeInitials key={employee.id} employee={employee} />
          ))}
        </div>
        <div
          className={`expert-search-item ${
            this.props.isSelected ? 'active' : ''
          }`}
          onClick={this.props.onClick}
        >
          <div className='my-project-item--title'>{project.projectName}</div>
          <div className='my-project-item--account'>
            {project.clientName}, {project.accountName}
          </div>
          <ProjectItemStats project={project} />
        </div>
        <div className='drag-and-drop-handle'>
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    )
  }
}

export default observer(MyProjectsItem)
